import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';

import shortid from 'shortid';
import lodash from 'lodash';
import * as actionTypes from '../../../../store/actions/actionTypes';
import ImageLoader from '../../ImageLoader';
import { openAPI } from '../../../../config';

class LeadGen extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      registerViaEmail: false,
      name: '',
      last_name: '',
      email: '',
      company_name: '',
      phone: '',
      error: false,
      message: '',
      info: '',
      customers: [],
    };
    this.ref_first_name = React.createRef();
    this.ref_last_name = React.createRef();
    this.ref_company_name = React.createRef();
    this.ref_company_email = React.createRef();
    this.ref_company_phone = React.createRef();
    this.leadGeneration = this.leadGeneration.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);

    this.validateEmail = this.validateEmail.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onChangeHandler = name => event => {
    this.setState({ [name]: event.target.value, error: false });
  };

  closePopUp = () => {
    this.props.setLeadGenPopUp(false);
  };

  validateEmail(email) {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    const shuffled = lodash.shuffle(this.props.vendorCustomers.results);
    this.setState({ customers: shuffled });
  }

  leadGeneration() {
    const { cookies } = this.props;

    if (
      !this.state.error &&
      Boolean(!!this.ref_first_name.current.value) &&
      Boolean(!!this.ref_company_phone.current.value) &&
      Boolean(!!this.ref_company_email.current.value) &&
      Boolean(!!this.ref_company_name.current.value)
    ) {
      if (this.validateEmail(this.ref_company_email.current.value)) {
        let payload = {};
        payload['first_name'] = this.ref_first_name.current.value;
        if (!!this.ref_last_name.current.value) {
          payload['last_name'] = this.ref_last_name.current.value;
        }
        payload['email'] = this.ref_company_email.current.value;
        payload['company_name'] = this.ref_company_name.current.value;
        payload['phone'] = this.ref_company_phone.current.value;
        payload['reviewing_company'] = this.state.reviewing_company;
        payload['submission_url'] = this.state.submission_url;

        openAPI
          .post(`${process.env.REACT_APP_API_URL}/workemailinfo`, payload, {
            withCredentials: true,
          })
          .then(response => {
            if (Number(response.data.success) === 1) {
              if (this._isMounted) {
                // cookies.set(
                //   '__isLeadGen',
                //   { value: false },
                //   { path: '/', expires: new Date(Date.now() + 172800 * 1000) }
                // );
                // console.log('Response :: ', response);
                // this.setState({ success: response.data.success });
                window.location.reload();
                // this.props.setLeadGenPopUp(false);
                // this.props.postLeadRegPopUp();
                // this.props.updateLeadGenStatus();
                // if (this.props.isLocked) {
                //   this.props.updateUnBlurredCountTestimonial();
                //   this.props.updateUnBlurredCountCaseStudy();
                //   this.props.updateUnBlurredCountVideo();
                // }
                // this.closePopUp();
              }
            } else if (Number(response.data.success) === 0) {
              const errmsg = Object.keys(response.data.errors).map(
                err => response.data.errors[err][0]
              );
              if (this._isMounted) {
                this.setState({ error: true, message: errmsg });
              }
            }
          });
      } else {
        alert('Invalid email id');
      }
    } else {
      if (!Boolean(!!this.ref_first_name.current.value)) {
        alert('First Name is mandatory field');
        return;
      }
      if (!Boolean(!!this.ref_company_name.current.value)) {
        alert('Company is mandatory field');
        return;
      }
      if (!Boolean(!!this.ref_company_email.current.value)) {
        alert('Email is mandatory field');
        return;
      }
      if (!Boolean(!!this.ref_company_phone.current.value)) {
        alert('Mobile Number is mandatory field');
        return;
      }
    }
  }

  render() {
    const fallbackImage = '/static/images/FC-Generic-Logo.webp';
    return (
      <React.Fragment>
        {this.state.registerViaEmail ? (
          <section
            className="overlay_popup overlay_grey competitorPopup leadgen_form"
            aria-hidden="false"
          >
            <div className="popBox">
              <a
                href="#close popup"
                className="close-overlay"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.closePopUp();
                  this.props.setLeadGenPopUp(false);
                }}
              >
                <span className="cross">X</span>
              </a>
              <div className="popup_overlay_screen">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="leadgen_popup_box">
                      <div className="left_box">
                        {this.state.customers.length > 0 && (
                          <div className="logo_container">
                            <ImageLoader
                              image={this.props.companyLogo}
                              fallbackImage={fallbackImage}
                            />
                          </div>
                        )}
                        <span className="trusted_txt">trusted by</span>
                        <div className="logo_container_box">
                          {this.state.customers.length > 1 &&
                            this.state.customers.slice(1, 6).map(customer => (
                              <div className="logo" key={shortid.generate()}>
                                <ImageLoader
                                  image={customer.logo}
                                  fallbackImage={fallbackImage}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="right_box">
                        <span className="instant_access_txt">
                          Instantly Access <br />
                          All {this.props.totalRefCount} Customer References
                        </span>
                        <p>
                          {`Validate yourself and get unlimited access to all ${this.props.companyName} case studies, testimonials, and customer videos.`}
                        </p>
                        <div className="cls_linkedin_leadgen_form">
                          {this.state.error && (
                            <span style={{ color: 'red' }}>
                              {this.state.message}
                            </span>
                          )}
                          <form>
                            <label className="firstname">
                              First Name
                              <input
                                type="text"
                                name="name"
                                className=""
                                // onChange={this.onChangeHandler('name')}
                                // value={this.state.name}
                                ref={this.ref_first_name}
                              />
                            </label>
                            <label className="lastname">
                              Last Name
                              <input
                                type="text"
                                name="name"
                                className=""
                                // onChange={this.onChangeHandler('last_name')}
                                // value={this.state.last_name}
                                ref={this.ref_last_name}
                              />
                            </label>
                            <label>
                              Company Name
                              <input
                                type="text"
                                name="name"
                                className=""
                                // onChange={this.onChangeHandler('company_name')}
                                // value={this.state.company_name}
                                ref={this.ref_company_name}
                              />
                            </label>
                            <label>
                              Company Email
                              <input
                                type="text"
                                name="name"
                                className=""
                                // onChange={this.onChangeHandler('email')}
                                // value={this.state.email}
                                ref={this.ref_company_email}
                              />
                            </label>
                            <label>
                              Phone
                              <input
                                type="text"
                                name="name"
                                className=""
                                // onChange={this.onChangeHandler('phone')}
                                // value={this.state.phone}
                                ref={this.ref_company_phone}
                              />
                            </label>
                            <input
                              type="button"
                              value="View Customer References"
                              onClick={e => {
                                e.preventDefault();
                                this.leadGeneration();
                              }}
                            />
                            <span className="sign_linkedin_link">
                              or{' '}
                              <a href={this.props.linkedInUrl}>
                                Sign in with Linkedin
                              </a>
                            </span>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section
            className="overlay_popup overlay_grey competitorPopup leadgen"
            aria-hidden="false"
          >
            <div className="popBox">
              <a
                href="#close popup"
                className="close-overlay"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.closePopUp();
                  this.props.setLeadGenPopUp(false);
                }}
              >
                <span className="cross">X</span>
              </a>
              <div className="popup_overlay_screen">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="header_img">
                      <img src="/images/leadgen_img_icon.webp" alt="" />
                    </div>
                    <div className="competitor_box leadgen_popup_box">
                      <div className="popupHeading">
                        <div className="leadgen_popup_txt">
                          <h1>
                            Instantly Access all {this.props.totalRefCount}{' '}
                            Customer References
                          </h1>
                          <h2>
                            {`Validate yourself and get unlimited access to all ${this.props.companyName} case studies, testimonials, and customer videos.`}
                          </h2>
                        </div>
                      </div>
                      <div className="leadgen_btn_linkedin">
                        <a
                          href={this.props.linkedInUrl}
                          onClick={e => {
                            // console.log('Linked click');
                            e.preventDefault();
                            window.location.replace(this.props.linkedInUrl);
                          }}
                        >
                          Sign in with Linkedin
                        </a>
                      </div>
                      <div className="sign_email">
                        or{' '}
                        <a
                          href="#sign in with email"
                          onClick={e => {
                            e.preventDefault();
                            if (this._isMounted) {
                              this.setState({ registerViaEmail: true });
                            }
                          }}
                        >
                          Sign in with Email
                        </a>
                      </div>
                      <div className="leadgen_trusted_box">
                        <div className="logo_img">
                          {this.state.customers.length > 0 && (
                            <img src={this.props.companyLogo} alt="" />
                          )}
                        </div>
                        <span className="leadgen_txt">trusted by</span>
                        <div className="leadgen_logobox">
                          {this.state.customers.length > 1 &&
                            this.state.customers.slice(1, 6).map(customer => (
                              <div className="logo" key={shortid.generate()}>
                                <ImageLoader
                                  image={customer.logo}
                                  fallbackImage={fallbackImage}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    vendorCustomers: state.vendorCommon.vendorCustomers,
    companyLogo: state.vendorCommon.logo,
    companyName: state.vendorCommon.name,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLeadGenStatus: () => {
      dispatch({ type: actionTypes.UPDATE_LEADGEN_STATUS, status: false });
    },

    updateUnBlurredCountTestimonial: () => {
      dispatch({
        type: actionTypes.NUM_UNBLURRED_REVIEW_TESTIMONIAL,
        num_unblurred_reviews: -1,
      });
    },
    updateUnBlurredCountCaseStudy: () => {
      dispatch({
        type: actionTypes.NUM_UNBLURRED_REVIEW_CASESTUDY,
        num_unblurred_reviews: -1,
      });
    },
    updateUnBlurredCountVideo: () => {
      dispatch({
        type: actionTypes.NUM_UNBLURRED_REVIEW_VIDEO,
        num_unblurred_reviews: -1,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(LeadGen));
